import type { VerificationStatus } from '../types';

export function canPublishWithoutEmailVerification(
  status: VerificationStatus | null | undefined,
): boolean {
  return status !== 'unverified';
}
